import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FireflySvgDonutChartModule } from '../svg-donut-chart/svg-donut-chart.module';
import { FireflySemiDonutChartComponent } from './semi-donut-chart.component';

@NgModule({
  imports: [CommonModule, FireflySvgDonutChartModule],
  declarations: [FireflySemiDonutChartComponent],
  exports: [FireflySemiDonutChartComponent]
})
export class FireflySemiDonutChartModule {}
